
import { toast } from "react-hot-toast"
let pathBack = "https://back.jedify.io"
const token = localStorage.getItem("token")
export const newsActions = {
    get: async () => {
        let res = await fetch(pathBack + "/api/news")
        let news = await res.json()
        return news.payload
    },
    save: async (data) => {
        let obj = {
            title: {
                es: data.get("titleES"),
                en: data.get("titleEN")
            },
            description: {
                es: data.get("descriptionES"),
                en: data.get("descriptionEN")
            },
            abstract: {
                es: data.get("resumenES"),
                en: data.get("resumenEN")
            },
            imgUrl: data.get("imgUrl"),
            tags: [...data.get("tags").split(",")]
        }
        let response = await fetch(pathBack + "/api/news", {
            method: "POST",
            body: JSON.stringify(obj),
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token
            }
        })
        let res = await response.json()
        return res
    },
    removeNew: async (id) => {
        let response = await fetch(`https://back.jedify.io/api/news/${id}`, {
            method: "POST",
            // Authorization: "Bearer " + token
        })
        // console.log(response);
        await response.json()
        return (
            toast.success("Eliminado correcatmente", {
                style: {
                    backgroundClip: "#f09236",
                    color: "black",
                    fontWeight: "bold"
                }
            })
        )
    },
    update: async (data) => {
        let id = data.get("id")
        let obj = {
            title: {
                es: data.get("titleES"),
                en: data.get("titleEN")
            },
            description: {
                es: data.get("descriptionES"),
                en: data.get("descriptionEN")
            },
            abstract: {
                es: data.get("resumenES"),
                en: data.get("resumenEN")
            },
            imgUrl: data.get("imgUrl"),
            tags: [...data.get("tags").split(",")]
        }
        let response = await fetch(`https://back.jedify.io/api/news/${id}`, {
            method: "PUT",
            body: JSON.stringify(obj),
            headers: {
                "Content-Type": "application/json",
                // 'Access-Control-Allow-Origin': '*'
                Authorization: "Bearer " + token
            }
        })
        let res = await response.json()
        return res
    }
}


export const casosActions = {
    get: async () => {
        let casos = []
        let prueba = await fetch(pathBack + "/api/casos")
        casos = await prueba.json()
        return casos.payload
    },
    save: async (data, token) => {
        let obj = {
            title: {
                es: data.get("titleES"),
                en: data.get("titleEN")
            },
            need: {
                es: data.get("needES"),
                en: data.get("needEN")
            },
            solution: {
                es: data.get("solutionES"),
                en: data.get("solutionEN")
            },
            imgUrl: data.get("imageUrl"),
            link: data.get("link")
        }
        let response = await fetch(pathBack + "/api/casos", {
            method: "POST",
            body: JSON.stringify(obj),
            headers: {
                Authorization: "Bearer " + token,
                "Content-Type": "application/json"
            }
        })
        let res = await response.json()
        return res
    },
    update: async (data) => {
        let id = data.get("id")
        let obj = {
            title: {
                es: data.get("titleES"),
                en: data.get("titleEN")
            },
            need: {
                es: data.get("needES"),
                en: data.get("needEN")
            },
            solution: {
                es: data.get("solutionES"),
                en: data.get("solutionEN")
            },
            imgUrl: data.get("imageUrl"),
            link: data.get("link")
        }
        let response = await fetch(`https://back.jedify.io/api/casos/${id}`, {
            method: "PUT",
            body: JSON.stringify(obj),
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token
            }
        })
        let res = await response.json()
        return res
    },
    removeCasos: async (id) => {
        let response = await fetch(`https://back.jedify.io/api/casos/${id}`, {
            method: "DELETE",
            Authorization: "Bearer " + token
        })

        await response.json()
        return (
            toast.success("Eliminado correcatmente", {
                style: {
                    backgroundClip: "#f09236",
                    color: "black",
                    fontWeight: "bold"
                }
            })
        )
    }
}


export const userActions = {
    logIn: async (user) => {
        let result = await fetch(pathBack + "/api/session/login", {
            method: "POST",
            body: JSON.stringify(user),
            headers: {
                "Content-Type": "application/json",
                'Access-Control-Allow-Origin': '*'
            }
        })

        let userlog = await result.json()
        return userlog
    }
}
